import axios from "axios";

  //create an instance of axios with a base url and headers 

  
const instance = axios.create({
  // baseURL: "http://localhost:8080/api",
  baseURL: "https://ems.olympusmarinegroup.com:9080/api/v1/",
  headers: {
    "Content-Type": "application/json",
  },
});

export default instance;
